module.exports = __webpack_public_path__ + "static/media/6.b6fe4d36.png";